import { useAuth0 } from "@auth0/auth0-react";
import React from "react";
import LoginButton from "./login-button";
import LogoutButton from "./logout-button";
import "./NavBarButtons.scss";

export const NavBarButtons = ({ menuOpen, activePage }) => {
  const { isAuthenticated } = useAuth0();
  const contactUsStyle = activePage === "/contact" ? {backgroundColor: "rgba(39, 55, 120, 0.5)"} : {backgroundColor: "#273778" };
  const divClassName = menuOpen ? "is-active has-text-weight-bold" : ""

  return (
    <div className={`navbar-end is-flex is-flex-direction-column ${divClassName} btns-container`}>
      {!isAuthenticated &&  <LoginButton /> }
      {isAuthenticated && <LogoutButton />  }
      <button
        className={"button work-with-us-btn" + (activePage === "/contact" ? " is-smaller" : "")}
        style={contactUsStyle}
        onClick={() => window.location.href="/contact"}
      >
        <span className="icon is-small" style={{color: "white"}}>
          <i className="fas fa-envelope"></i>
        </span>
        <span style={{color: "white", paddingLeft: "10px"}}>Work with us</span>
      </button>
    </div>
  );
};